// Compliance / Audit — read-only PHI-ACCESS log viewer. Shows access-event METADATA only (actor,
// subject, resource, action, timestamp, PHI class). It NEVER renders raw chat bodies or any
// decrypted PHI payload (D5) — the API doesn't expose them and there is no body field here.
import { useState } from "react";
import { Surface } from "@championcare/ui";
import { useApi } from "../api";
import { useAsync } from "../lib/useAsync";
import { formatDateTime, shortId } from "../lib/format";
import { Loading, ErrorState, EmptyState, PageHeader, StatusBadge } from "../components/ui";

export function Compliance() {
  const api = useApi();
  const [limit, setLimit] = useState(100);
  const { data, loading, error } = useAsync(() => api.audit(limit), [limit]);

  return (
    <div className="page">
      <PageHeader
        title="Compliance"
        sub="PHI-access audit log — event metadata only, never message bodies."
      />
      <div className="page__bar">
        <label className="muted">
          Rows{" "}
          <select
            className="input"
            value={limit}
            onChange={(e) => setLimit(Number(e.target.value))}
          >
            <option value={50}>50</option>
            <option value={100}>100</option>
            <option value={250}>250</option>
          </select>
        </label>
      </div>
      <Surface className="card">
        {loading ? (
          <Loading />
        ) : error ? (
          <ErrorState message={error} />
        ) : (data ?? []).length ? (
          <table className="tbl">
            <thead>
              <tr>
                <th>When</th>
                <th>Actor</th>
                <th>Role</th>
                <th>Action</th>
                <th>Resource</th>
                <th>Subject</th>
                <th>PHI class</th>
              </tr>
            </thead>
            <tbody>
              {(data ?? []).map((a) => (
                <tr key={String(a.id)}>
                  <td className="mono">{formatDateTime(a.at)}</td>
                  <td className="mono">{shortId(a.actor_id)}</td>
                  <td>{a.actor_role ?? "—"}</td>
                  <td>{a.action}</td>
                  <td>{a.entity}</td>
                  <td className="mono">{shortId(a.entity_id)}</td>
                  <td>
                    <StatusBadge value={a.phi_class ?? "NONE"} />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          <EmptyState>No audit events.</EmptyState>
        )}
      </Surface>
    </div>
  );
}
